function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import { css, color } from "../../../../styles/theme";
import Select from "../../../basic/Select";
import SvgButton from "../../../basic/SvgButton";
import { SvgClose, SvgChevronDown, SvgChevronUp } from "../../../../svg";
import { default as Styles, focusedStyle, dropdownSelectStyle, menuContainerStyle, dropdownOption, dropdownOptionFocused } from "./ToolbarTableStyles";
var DropdownFilter = /*#__PURE__*/function (_React$Component) {
  function DropdownFilter(_props, context) {
    var _this;
    _classCallCheck(this, DropdownFilter);
    _this = _callSuper(this, DropdownFilter, [_props, context]);
    _defineProperty(_this, "clearRenderer", function () {
      return _this.iconRenderer(/*#__PURE__*/React.createElement(SvgClose, {
        size: 15,
        title: "Clear selection",
        hoverColor: color.danger
      }));
    });
    _defineProperty(_this, "arrowRenderer", function (_ref) {
      var isOpen = _ref.isOpen;
      var props = {
        size: 15,
        hoverColor: color.primary
      };
      return _this.iconRenderer(isOpen ? /*#__PURE__*/React.createElement(SvgChevronUp, props) : /*#__PURE__*/React.createElement(SvgChevronDown, props));
    });
    _this.state = {
      focus: false
    };
    return _this;
  }
  _inherits(DropdownFilter, _React$Component);
  return _createClass(DropdownFilter, [{
    key: "generatePlaceholder",
    value: function generatePlaceholder() {
      var placeholder = this.props.placeholder;
      // Account for placeholder translations passed as functions.
      var placeholderText = typeof placeholder === 'function' ? placeholder() : placeholder;
      return /*#__PURE__*/React.createElement("div", css(Styles.dropdownPlaceholder), placeholderText || 'Select...');
    }
  }, {
    key: "valueRenderer",
    value: function valueRenderer(_ref2) {
      var label = _ref2.label;
      return /*#__PURE__*/React.createElement("div", css(Styles.dropdownValue), label);
    }
  }, {
    key: "optionRenderer",
    value: function optionRenderer(_ref3) {
      var style = _ref3.style,
        focusOption = _ref3.focusOption,
        selectValue = _ref3.selectValue,
        focusedOption = _ref3.focusedOption,
        key = _ref3.key,
        option = _ref3.option;
      return /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return selectValue(option);
        },
        onMouseOver: function onMouseOver() {
          return focusOption(option);
        },
        key: key,
        style: Object.assign({}, _objectSpread(_objectSpread({}, style), dropdownOption), option === focusedOption && _objectSpread({}, dropdownOptionFocused))
      }, option.label);
    }
  }, {
    key: "iconRenderer",
    value: function iconRenderer(icon) {
      return /*#__PURE__*/React.createElement(SvgButton, {
        htmlAttributes: {
          tabIndex: -1
        },
        size: "sm",
        type: "icon",
        style: {
          padding: 'unset'
        },
        svgElement: icon
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        options = _this$props.options,
        onUpdate = _this$props.onUpdate,
        value = _this$props.value,
        width = _this$props.width;
      var focus = this.state.focus;
      return /*#__PURE__*/React.createElement("div", css(Styles.dropdownWrapper), /*#__PURE__*/React.createElement(Select, {
        style: _objectSpread(_objectSpread({
          width: width || 200
        }, dropdownSelectStyle), focus ? focusedStyle : {}),
        value: value,
        valueRenderer: this.valueRenderer,
        options: options,
        onChange: function onChange(option) {
          return onUpdate(option && option.value);
        },
        clearable: true,
        optionHeight: 46,
        optionRenderer: this.optionRenderer,
        clearRenderer: this.clearRenderer,
        arrowRenderer: this.arrowRenderer,
        placeholder: this.generatePlaceholder(),
        onFocus: function onFocus() {
          return _this2.setState({
            focus: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            focus: false
          });
        },
        menuContainerStyle: menuContainerStyle
      }));
    }
  }]);
}(React.Component);
export default DropdownFilter;